import React from 'react';
import { componentService } from 'js/services/component.service';

export const PromoCode = React.lazy(() => import(/* webpackChunkName: "promoCode" */ './PromoCode'));

// <hub2-promocode></hub2-promocode>
componentService.registerWebContentComponents({ PromoCode });
